import type { InvoiceTimelineResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { INVOICE_TIMELINE_PAGE_SIZE } from './constants';
import {
  zodInvoiceTimelineQueryParamsSchema,
  zodInvoiceTimelineResponseSchema,
} from './validations';

/**
 * Fetches the audit timeline of an invoice as a single page, newest event first.
 *
 * @param invoiceId - Invoice identifier.
 * @param options - Request options supplied by TanStack Query.
 * @returns Paginated timeline response.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/get_invoice_timeline_invoices__invoice_id__timeline_get
 */
export async function fetchInvoiceTimeline(
  invoiceId: UUID,
  options?: KyRequestOptions,
) {
  return vestigasApi
    .get(ENDPOINT.INVOICE.GET_TIMELINE(invoiceId), {
      ...options,
      searchParams: { limit: INVOICE_TIMELINE_PAGE_SIZE },
      validate: {
        ...options?.validate,
        isResponseSensitive: true,
        response: zodInvoiceTimelineResponseSchema,
        searchParams: zodInvoiceTimelineQueryParamsSchema,
      },
    })
    .json<InvoiceTimelineResponse>();
}
